import { IoMdInformationCircleOutline } from 'react-icons/io';
import { HStack, VStack } from 'ui_2';
import { AccountAndParcBalance } from './AccountAndParc';
import { useNavigate } from '@tanstack/react-router';
import { Route as information_route } from '@src/routes/info';
import MysteryCityIcon from '../../public/assets/MysteryCityIcon.png';
import MysteryCityLogo from '../../public/assets/MysteryCityLogo.png';
import { Counter } from './Counter';
import { RoundsAndScore } from './RoundsAndScore';
import { MuteButton } from './MuteButton';
import useWindowDimensions from '@puzzlehq/frontend-utils/src/hooks/useWindowDimensions';

type Props = {
  showInfo?: boolean;
  counter?: number;
  roundsAndScore?: {
    round: number;
    rounds: number;
    score: number;
  };
  showLogo?: boolean;
};

export const Header = ({
  showInfo = true,
  counter,
  roundsAndScore,
  showLogo = false,
}: Props) => {
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const isMobile = width < 800;

  return (
    <div className='absolute left-0 top-0 z-10 flex w-full flex-col lg:flex-row lg:justify-center'>
      <div className='relative w-full lg:hidden'>
        <HStack className='left-0 w-full items-start px-4 pt-6'>
          <VStack className='gap-2'>
            <img
              src={showLogo ? MysteryCityLogo : MysteryCityIcon}
              className={
                showLogo
                  ? `${isMobile ? 'max-w-[175px]' : 'max-w-[250px]'}`
                  : 'h-16 w-16 object-contain'
              }
            />
            {showInfo && (
              <IoMdInformationCircleOutline
                className='h-[30px] w-[30px] text-2xl text-aqua'
                onClick={() => navigate({ to: information_route.to })}
              />
            )}
            {counter !== undefined && <Counter counter={counter} />}
            {roundsAndScore !== undefined && (
              <RoundsAndScore
                round={roundsAndScore.round}
                rounds={roundsAndScore.rounds}
                score={roundsAndScore.score}
              />
            )}
          </VStack>
          <HStack className='flex-grow' />
          <VStack className='gap-4'>
            <AccountAndParcBalance gameActive={roundsAndScore !== undefined} />
            <HStack className='w-full justify-end'>
              <MuteButton />
            </HStack>
          </VStack>
        </HStack>
      </div>
      <div className='hidden w-full lg:flex'>
        <HStack className='left-0 w-full items-start justify-between px-4 pt-6'>
          <img src={MysteryCityLogo} className='h-[112px] w-[262px]' />
          <HStack className='items-top gap-4'>
            {counter !== undefined && <Counter counter={counter} />}
            {roundsAndScore !== undefined && (
              <RoundsAndScore
                round={roundsAndScore.round}
                rounds={roundsAndScore.rounds}
                score={roundsAndScore.score}
              />
            )}
          </HStack>
          <VStack className='items-end gap-4'>
            <AccountAndParcBalance gameActive={roundsAndScore !== undefined} />
            <HStack className='gap-4'>
              {showInfo && (
                <IoMdInformationCircleOutline
                  className='h-[30px] w-[30px] text-2xl text-aqua'
                  onClick={() => navigate({ to: information_route.to })}
                />
              )}
              <MuteButton />
            </HStack>
          </VStack>
        </HStack>
      </div>
    </div>
  );
};
